import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard implements CanActivate {
  constructor(private router:Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let validation;
      try {
        const auth = localStorage.getItem('auth');
        if (auth && auth === '1') {
          validation = true;
        } else {
          throw new Error('Not logged in');
        }
      } catch (error) {
        this.router.navigate(['/login']);
        validation = false;
      }
      return validation;
  }
  
}
